export default {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  userRole (state) {
    return state.userInfo && state.userInfo.role ? state.userInfo.role : null
  }
}
